import whyChooseImage from '../../../../images/guests.jpg';
import './WhyChoose.css';

const benefits = [
  'Easy to use, Payment required',
  'Unlimited events and guests',
  'WhatsApp sharing integration',
  'Real-time RSVP tracking',
  'Beautiful invitation templates',
  'Mobile-friendly design',
];

function WhyChoose() {
  return (
    <section className="whychoose">
      <div className="whychoose-content">
        <h2 className="whychoose-title">Why Choose AttendX?</h2>
        <ul className="whychoose-list">
          {benefits.map((item) => (
            <li key={item} className="whychoose-item">
              <svg className="whychoose-check" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="10" fill="#6C63FF" />
                <path d="M6 10.5l2.5 2.5 5.5-6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="whychoose-image">
        <img src={whyChooseImage} alt="Wedding event" />
      </div>
    </section>
  );
}

export default WhyChoose;
